import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CommissionSalePromotionsService } from 'src/app/services/commission-sale-promotions.service';
import { CreatorService } from 'src/app/services/creator.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';
import { ModalCommissionSalePromotionsComponent } from 'src/app/shared/modal-commission-sale-promotions/modal-commission-sale-promotions.component';
import { ModalValidateCommissionComponent } from 'src/app/shared/modal-validate-commission/modal-validate-commission.component';
import { ModalSchemeConfiguratorComponent } from 'src/app/shared/modal-sheme-configutator/modal-scheme-configurator.component';
import { CommissionSalePromotion } from 'src/app/model/commission-sale-promotion';
import { ConfiguratedSchemaModel, CreatedSchemas, ValidateSchema } from 'src/app/model/other-catalogs-models';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-scheme-configurator',
  templateUrl: './scheme-configurator.component.html',
  styleUrls: ['./scheme-configurator.component.css']
})
export class SchemeConfiguratorComponent implements OnInit {
  // estado pagina
  public page:string='SchemeConfigurator';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public listSalePromotions:CommissionSalePromotion[]=[];
  public listSalePromotionsLog:any[]=[];
  public listCreatedSchemas: CreatedSchemas[]=[];
  public activeOrinactive:number= 0;
  public statusResponse: string = "";
  public InvalidValues: string [] = []

  public listValidateSchema: ValidateSchema []=[];
  public listConfiguratedSchema: ConfiguratedSchemaModel [] = [] ;

  public active:number=1;

  // Opciones de Datatable
  @ViewChild(DataTableDirective, {static: false})
  private datatableElement: DataTableDirective;

  // opciones datatables
  dtOptions={
    order:[],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 },
      { responsivePriority: 2, width:100, targets: -2 }
    ],
    select: 'single',
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    paging:true,
    pageLength: 10,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  dtOptionsLog={
    order:[],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    // dom: 'Bfrtip',
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private commissionSalePromotionsService:CommissionSalePromotionsService,
    private otherCatalogService: OtherCatalogsService,
    public utils:UtilitiesService,
    private creator:CreatorService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) { }

  ngOnInit() {
    this.getCatalogs();
  }

  add=()=> {
    let salePromotion=this.creator.newCommissionSalePromotion();
    salePromotion.promotionDateIni=null;
    salePromotion.promotionDateFin=null;
    salePromotion.saleAmountFrom=null;
    salePromotion.saleAmountTo=null;
    salePromotion.additionalSchemaBase=false;
    salePromotion.digitalOrigin=true;
    salePromotion.unifielDigifiel=true;
    salePromotion.traditionalOrigin=true;
    salePromotion.minCreditAdv=false;
    salePromotion.minCreditAdvPerc=null;
    salePromotion.observations='';
    let modalRef=this.modalService.open(ModalSchemeConfiguratorComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.salePromotion=salePromotion;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  edit=(subSchemaHeader:CreatedSchemas)=> {

    let salePromotion=this.creator.newCommissionSalePromotion();
    salePromotion.promotionDateIni=null;
    salePromotion.promotionDateFin=null;
    salePromotion.saleAmountFrom=null;
    salePromotion.saleAmountTo=null;
    salePromotion.additionalSchemaBase=false;
    salePromotion.digitalOrigin=true;
    salePromotion.unifielDigifiel=true;
    salePromotion.traditionalOrigin=true;
    salePromotion.minCreditAdv=false;
    salePromotion.minCreditAdvPerc=null;
    salePromotion.observations='';
    let modalRef=this.modalService.open(ModalSchemeConfiguratorComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.subSchemaHeader = subSchemaHeader;
    modalRef.componentInstance.salePromotion=salePromotion;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.listConfiguratedSchema = this.listConfiguratedSchema;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  detail=(createdSchema:CreatedSchemas)=> {
    let modalRef=this.modalService.open(ModalValidateCommissionComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.listValidateSchema=this.listValidateSchema;
    modalRef.componentInstance.esquema=createdSchema.ESQUEMA;
    modalRef.componentInstance.fondeo=createdSchema.FONDEO;
    modalRef.componentInstance.linea=createdSchema.LINEA;
    modalRef.componentInstance.estructura=createdSchema.ESTRUCTURA;
    modalRef.componentInstance.puesto=createdSchema.PUESTO;

    modalRef.componentInstance.mode='detail';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
      }
    );
  }

  delete=(salePromotion:CommissionSalePromotion)=> {
    let modalRef=this.modalService.open(ModalCommissionSalePromotionsComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.salePromotion={...salePromotion};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='delete';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  toggleActive=(idSubSchema: number)=> {
    let modalRef=this.modalService.open(ModalCommissionSalePromotionsComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.salePromotion={idSubSchema};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='toggleActive';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  logDetails=(salePromotionLog:any)=> {
    let modalRef=this.modalService.open(ModalCommissionSalePromotionsComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.salePromotion=null;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='detail';
    modalRef.componentInstance.logDetails=salePromotionLog.details;
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
      }
    );
  }

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.commissionSalePromotionsService.getListSalePromotions(),
      this.otherCatalogService.getCreatedSchemas()
    )
    .pipe(
      tap(([
          salePromoResp, createdSchemas]:[any, any])=> {
        if(salePromoResp /*&& salePromoLogResp*/ && createdSchemas) {
          this.listSalePromotions=salePromoResp.data;
          this.listCreatedSchemas = createdSchemas.data
          console.log ( createdSchemas)
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al obtener la información'));
      })
    )
    .subscribe();
  }

  getAndUpdateSelectedHSchema=(subSchemaHeader:number)=> {

    this.commissionSalePromotionsService.getStatusSchema(subSchemaHeader)

      .pipe(
        tap((resp:any)=> {


          this.activeOrinactive=resp.data[0].activeId;

          if(this.activeOrinactive == 0 ){
            this.activeOrinactive = 1
            this.statusResponse = "SE HA ACTIVADO "
          }else if (this.activeOrinactive ==1){
            this.activeOrinactive =0
            this.statusResponse = "SE HA DESACTIVADO "
          }
          this.updateSelectedHSchema(subSchemaHeader,this.activeOrinactive);




        }),
        catchError(error=> {
          this.viewStatus=-1;
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
        })
      )
      .subscribe();
  }


  updateSelectedHSchema=(subSchemaHeader:number, activeId:number)=> {
    this.viewStatus = 0;
    this.commissionSalePromotionsService.updateStatusSchema(subSchemaHeader, activeId)
      .pipe(
        tap((resp:any)=> {
        console.log(resp);


        Swal.fire("CORRECTO ",this.statusResponse + "EL SUBSCHEMA " + subSchemaHeader ,  'success')

        this.getCatalogs();

        }),
        catchError(error=> {
          this.viewStatus=1;
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
        })
      )
      .subscribe();
  }

  getValidateValues=(subSchemaHeader:CreatedSchemas)=> {
    console.log(subSchemaHeader.SubSchemaHeaderId)
    this.commissionSalePromotionsService.getValidateSchema(subSchemaHeader.SubSchemaHeaderId)
      .pipe(
        tap((resp:any)=> {
          this.listValidateSchema = resp.data;
          console.log(this.listValidateSchema);
          this.detail(subSchemaHeader);



        }),
        catchError(error=> {

          return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
        })
      )
      .subscribe();
  }

  getConfiguratedSchema=(subSchemaHeader:CreatedSchemas)=> {
    console.log(subSchemaHeader.SubSchemaHeaderId)
    this.commissionSalePromotionsService.getConfiguratedSchema(subSchemaHeader.SubSchemaHeaderId)
      .pipe(
        tap((resp:any)=> {
          this.listConfiguratedSchema = resp.data;
          //console.log(this.listConfiguratedSchema);
          this.edit(subSchemaHeader);
        }),
        catchError(error=> {

          return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
        })
      )
      .subscribe();
  }
  ValidateIfActivate=(subSchemaHeader:CreatedSchemas)=> {
    this.InvalidValues = [];
    this.viewStatus = 0;
    console.log(subSchemaHeader.SubSchemaHeaderId)
    if (subSchemaHeader.ActiveId == 1){
      this.getAndUpdateSelectedHSchema(subSchemaHeader.SubSchemaHeaderId);
    }else{
      this.commissionSalePromotionsService.ValidateIfActivate(subSchemaHeader.SubSchemaHeaderId)
      .pipe(
        tap((resp:any)=> {
          console.warn (resp)
          if(resp.codeHttpStatus == 200 && resp.data == null){
            this.getAndUpdateSelectedHSchema(subSchemaHeader.SubSchemaHeaderId)

          }else if (resp.codeHttpStatus == 200 && resp.data != null) {


            resp.data.forEach((el)=>{
              this.InvalidValues.push('<BR> <label style="color: green;">  ' +el.Description + '</label> # ID ('+ el.SubSchemaHeader+') ' );
            });
            console.log(this.InvalidValues)
            Swal.fire("ADVERTENCIA ", "LOS CONVENIOS YA EXISTEN EN:  " + this.InvalidValues  , 'warning' )
            this.viewStatus = 1;
          }
        }),
        catchError(error=> {

          return of(this.toastr.error('Ocurrió un error para validar la activación'));
        })
      )
      .subscribe();
    }


  }


}
